import store from 'store';
import { server_connection } from 'config';

export const GET_STUDENT_PROGRESS               = '[PROGRESS APP] GET STUDENT PROGRESS';
export const UPDATE_CHOICE                      = '[PROGRESS APP] UPDATE CHOICE';
export const UPDATE_COMPANY_CHOICE              = '[PROGRESS APP] UPDATE COMPANY CHOICE';
export const RESET_STORE                        = '[PROGRESS APP] RESET STORE';

export function getStudentProgress(student_id) {
    return (dispatch, getState) => {
        fetch(server_connection+'/progress/get_student_progress/'+ student_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_STUDENT_PROGRESS,
                    payload: data,
                });
            });
    }
}

export function updateChoice(choice) {
    return {
        type: UPDATE_CHOICE,
        payload: choice
    }
}

export function updateCompanyChoice(choice) {
    return {
        type: UPDATE_COMPANY_CHOICE,
        payload: choice
    }
}

export function resetStore() {
    return {
        type: RESET_STORE,
        payload: true
    }
}


// WEBPACK FOOTER //
// src/main/content/progress/store/actions/progress.actions.js